import styled from "styled-components";
import { Link } from "react-router-dom";
import { useMatch, useResolvedPath } from "react-router";
import MobileHeader from "./Mobile/MobileHeader";
import { useState, useEffect } from "react";

const NavBarSpacer = styled.div`
  height: 76px;
`;
const NavBarBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 76px;
  background-color: #1d1311;
  z-index: 100;
`;

const BravoLogo = styled(Link)`
  position: relative;
  left: ${(props) => (props.$scrolled ? "90px" : "0")};
  top: -20px;
  background-image: url("/bravo-circle-logo.png");
  background-size: cover;
  z-index: 10;
  border-radius: 50%;
  width: ${(props) => (props.$scrolled ? "70px" : "180px")};
  height: ${(props) => (props.$scrolled ? "70px" : "180px")};
  background-color: #1d1311;
  transition: all 0.8s ease-in-out;
`;

const LinkContainer = styled.div`
  font-family: "Figtree", sans-serif;
  font-weight: 800;
  font-size: 17px;
  letter-spacing: 2px;
  position: fixed;
  z-index: 200;
  top: 0;
  height: 60px;
  /* Modify width to not cover the entire screen, allowing space for the ContactButton */
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  gap: 52px;
  align-items: flex-end;
  padding-bottom: 16px;
  justify-content: center;

  a {
    position: relative;
    color: white;
    text-decoration: none;
  }

  .active {
    color: #d5eeca;
    border-bottom: 2px solid #d5eeca;
  }

  a::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    height: 2px;
    width: 100%;
    background: #d5eeca;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.2s ease;
  }

  a:hover::after {
    transform: scaleX(1);
  }
  a:hover {
    color: #d5eeca;
    transition: color 0.2s ease;
  }
`;

export const ContactButton = styled(Link)`
  letter-spacing: 1px;
  font-family: "Figtree", sans-serif;
  font-weight: 800;
  background: #d5eeca;
  color: #1d1311;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 6px 14px !important;
  text-decoration: none;
  text-align: center;
  font-size: 15px;
  cursor: pointer;

  &:hover {
    background: rgba(213, 238, 202, 0.93);
    transition: background 0.2s ease;
  }
`;

export function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  return (
    <Link to={to} {...props} className={isActive ? "active" : ""}>
      {children}
    </Link>
  );
}

const Spreader = styled.div`
  position: fixed;
  left: 50%; /* Center horizontally */
  transform: translateX(-50%); /* Align center from left edge */
  z-index: 1000; /* Increase z-index to be higher than LinkContainer */
  top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 98%;
  max-width: 1200px;
  padding: 14px;
  pointer-events: none; /* Make the entire container pass-through for clicks */

  /* But enable pointer events for children */
  & > * {
    pointer-events: auto;
  }
`;

export default function Header({ isMobile }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  return (
    <>
      {isMobile ? (
        <MobileHeader />
      ) : (
        <>
          <NavBarSpacer />
          <NavBarBackground />
          <LinkContainer>
            <span>
              <CustomLink to="/">HOME</CustomLink>
            </span>
            <span>
              <CustomLink to="/services">SERVICES</CustomLink>
            </span>
            <span>
              <CustomLink to="/testimonials">TESTIMONIALS</CustomLink>
            </span>
          </LinkContainer>
          <Spreader>
            <BravoLogo to="/" $scrolled={scrolled} />
            <ContactButton to="/contact">CONTACT</ContactButton>
          </Spreader>
        </>
      )}
    </>
  );
}
